import { MediaSubTypeEnum } from '@arhs-fleetback/types/entities/media';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ENTITY_TYPE } from 'modules/app/constants';

export const REQUEST_RELATES = {
  MOBILE_APP: 'MOBILE_APP',
  WEB_APP: 'WEB_APP',
  KIOSK: 'KIOSK',
  OUTGOING_COMM: 'OUTGOING_COMM',
  OTHER: 'OTHER',
};

export const REQUEST_RELATES_OPTIONS = [
  {
    value: REQUEST_RELATES.MOBILE_APP,
    label: <FormattedMessage id="notifications.navigation.table.channel.mobile" defaultMessage="Mobile app" />
  },
  {
    value: REQUEST_RELATES.WEB_APP,
    label: <FormattedMessage id="reportIssue.webApp" defaultMessage="Web app" />
  },
  {
    value: REQUEST_RELATES.KIOSK,
    label: <FormattedMessage id="reportIssue.aKiosk" defaultMessage="a Kiosk" />
  },
  {
    value: REQUEST_RELATES.OUTGOING_COMM,
    label: <FormattedMessage id="reportIssue.outgoingCommunication" defaultMessage="Outgoing communication" />
  },
  {
    value: REQUEST_RELATES.OTHER,
    label: <FormattedMessage id="other" defaultMessage="Other" />
  },
];

export const TERNARY_RESPONSE = {
  YES: 'YES',
  NO: 'NO',
  I_DONT_KNOW: 'I_DONT_KNOW',
};

export const YES_NO_OPTIONS = [
  {
    value: TERNARY_RESPONSE.YES,
    label: <FormattedMessage id="yes" defaultMessage="Yes" />
  },
  {
    value: TERNARY_RESPONSE.NO,
    label: <FormattedMessage id="no" defaultMessage="No" />
  },
  {
    value: TERNARY_RESPONSE.I_DONT_KNOW,
    label: <FormattedMessage id="reportIssue.iDontKnow" defaultMessage="I don't know" />
  },
];

export const UPLOAD_PARAMS = {
  subType: MediaSubTypeEnum.MEDIAS,
  entityType: ENTITY_TYPE.HELPDESK,
};

export const MAX_DEFAULT_SUMMARY_LEGEND_LENGTH = 120;

export const SUMMARY_PATTERN = /^[^\n\r\t\x00-\x1F\x7F]+$/;
